var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.on, expression: "on" }
      ],
      staticClass: "igc-ball"
    },
    [
      _c(
        "div",
        { staticClass: "ig--close", on: { click: _vm.ballclose } },
        [
          _c("sui-icon", {
            staticClass: "ig--icon",
            attrs: { name: "close", fill: "#fff" }
          })
        ],
        1
      ),
      _c("div", {
        staticClass: "ig--image",
        style: { "background-image": "url(" + _vm.ball.img + ")" },
        on: {
          click: function($event) {
            return _vm.to(_vm.ball.url)
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }